export const MOBILE_SIDEBAR_BREAKPOINT = 992;

export function isMobileSidebarLayout(width = typeof window !== 'undefined' ? window.innerWidth : MOBILE_SIDEBAR_BREAKPOINT) {
    return width < MOBILE_SIDEBAR_BREAKPOINT;
}

/**
 * No tema legado, abaixo de 992px o CSS inverte a semântica de `is_show_sidebar`:
 * - true  => menu recolhido (fora da tela)
 * - false => drawer aberto
 */
export function isSidebarVisuallyOpen(showSidebar, width = typeof window !== 'undefined' ? window.innerWidth : MOBILE_SIDEBAR_BREAKPOINT) {
    if (isMobileSidebarLayout(width)) {
        return !showSidebar;
    }

    return !!showSidebar;
}

export function getDefaultSidebarStoreState(width = typeof window !== 'undefined' ? window.innerWidth : MOBILE_SIDEBAR_BREAKPOINT) {
    if (isMobileSidebarLayout(width)) {
        const savedState = localStorage.getItem('sidebar_state_mobile');
        if (savedState !== null) {
            return savedState === 'true';
        }

        // true = menu recolhido no CSS mobile/tablet
        return true;
    }

    const savedState = localStorage.getItem('sidebar_state');
    if (savedState !== null) {
        return savedState === 'true';
    }

    return true;
}
